import { Component } from '@angular/core';

@Component({
    selector: 'admin-rules',
    templateUrl: './rule.component.html',
    styleUrls: ['./rule.component.css']
})
/**
 * Component to display the rules.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class RuleComponent {
}



// WEBPACK FOOTER //
// ./src/app/admin/rules/rule.component.ts